import React, { useCallback } from "react";
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import ButtonGroup from '@mui/joy/ButtonGroup';
import Button from '@mui/joy/Button';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PrintIcon from '@mui/icons-material/Print';
import { REP_BLOCK, PRE_BLOCK, TOP_BLOCK } from "../../../../shared/Data/typeDirs";
import { genId } from "../../../../shared/utils";

export function ViewModeToggle({ settings, setSettings, controls, controlReducer }) {
  const { readOnly, printPreview } = settings

  const setViewMode = useCallback((mode) => {
    console.log('switching view modes', mode, printPreview)
    if(printPreview){
      let newControls = controls.filter(itm => [REP_BLOCK, PRE_BLOCK, TOP_BLOCK].includes(itm.type)).map(block=>({
        ...block,
        schema: block.type === REP_BLOCK ? 'reportBlockSchema' : block.type === PRE_BLOCK ? 'preambleBlockSchema' : 'topBlockSchema'
      }))
        controlReducer({ type: 'set_full_controls', name: 'websocket', controls: newControls })
    }
    if (mode === 'edit') {
      setSettings({ ...settings, readOnly: false, printPreview: false })
    } else if (mode === 'readonly') {
      setSettings({ ...settings, readOnly: true, printPreview: false })
    } else if (mode === 'print') {
      // Handle print preview logic
      let newControls = []
      for (let block of controls) {
        let newSchema
        switch (block.type) {
          case REP_BLOCK:
            newSchema = 'exportSchema'; break;
          case PRE_BLOCK:
            newSchema = 'exportPreambleBlockSchema'; break;
          case TOP_BLOCK:
            newSchema = 'exportTopBlockSchema'; break;
          default:
            newSchema = block.schema; break;
        }
        newControls.push({
          ...block,
          schema: newSchema
        })
      }
      newControls.splice(1, 0, { _id: genId(), schema: 'frontMatterSchema', type: 'frontMatter' })
      const lastPreambleIdx = newControls.findLastIndex(itm => itm.type === PRE_BLOCK) + 1 || 2
      newControls.splice(lastPreambleIdx, 0, { _id: genId(), schema: 'exportTableOfContentsSchema', type: 'tableOfContents' })

      setSettings({ ...settings, readOnly: true, printPreview: true })
      controlReducer({ type: 'set_full_controls', name: 'websocket', controls: newControls })
      return;
    }

  }, [settings, setSettings, controls, controlReducer])

  const handlePrintModeToggle = useCallback(() => {
    if (printPreview && settings.printPreview) {
      return;
    }

    if (printPreview) {
      // Switch back to edit mode when toggling off print preview
      setViewMode('edit')
      // Restore original controls
      
    } else {
      setViewMode('print')
    }
  }, [printPreview, setViewMode, controls, controlReducer])

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: { xs: '100%', sm: 'auto' } }}>
      <Typography level="body-sm" sx={{ whiteSpace: 'nowrap' }}>

      </Typography>
      <ButtonGroup size="sm" variant="outlined">
        <Button
          variant={!readOnly && !printPreview ? 'solid' : 'outlined'}
          onClick={() => setViewMode('edit')}
          startDecorator={<EditIcon />}
          size="sm"
          className={`btn-responsive ${!readOnly && !printPreview ? 'btn-custom-primary-solid' : 'btn-custom-primary'}`}
        >
          Edit mode
        </Button>
        <Button
          variant={readOnly && !printPreview ? 'solid' : 'outlined'}
          onClick={() => setViewMode('readonly')}
          size="sm"
          startDecorator={<VisibilityIcon />}
          className={`btn-responsive ${readOnly && !printPreview ? 'btn-custom-primary-solid' : 'btn-custom-primary'}`}
        >
          Read Only
        </Button>
        <Button
          size="sm"
          variant={printPreview ? 'solid' : 'outlined'}
          className={`btn-responsive ${printPreview ? 'btn-custom-primary-solid' : 'btn-custom-primary'}`}
          onClick={handlePrintModeToggle}
          startDecorator={<PrintIcon />}
        >
          Print Preview
        </Button>
      </ButtonGroup>
    </Box>
  )
}